// @flow
import React from 'react';
import { ShowLoaderIfAnyQueryIsPending } from '@presentational/ShowLoaderIfAnyQueryIsPending';
import { UserContextProvider } from '@src/contexts/UserContextProvider';
import { SPStreamingProjectContextProvider } from '@streaming-projects/sp-page/contexts/SPStreamingProjectContextProvider';
import { SPOrgContextProvider } from '@streaming-projects/orgs/contexts/SPOrgContextProvider';
import { SPMetaDataContextProvider } from '@streaming-projects/orgs/contexts/SPMetaDataContextProvider';

import { SPTableFlowWorkloadTopLevelContainerForm } from './SPTableFlowWorkloadTopLevelContainerForm';
import { SPTableFlowWorkloadBreadcrumbs } from './breadcrumbs/SPTableFlowWorkloadBreadcrumbs';
import { SPTableFlowWorkloadContextProvider } from './contexts/SPTableFlowWorkloadContextProvider';

export const SPTableFlowWorkloadTopLevelContainer = () => {
  return (
    <>
      <ShowLoaderIfAnyQueryIsPending />
      <UserContextProvider>
        <SPOrgContextProvider>
          <SPStreamingProjectContextProvider>
            <SPMetaDataContextProvider>
              <SPTableFlowWorkloadContextProvider>
                <SPTableFlowWorkloadBreadcrumbs />
                <SPTableFlowWorkloadTopLevelContainerForm />
              </SPTableFlowWorkloadContextProvider>
            </SPMetaDataContextProvider>
          </SPStreamingProjectContextProvider>
        </SPOrgContextProvider>
      </UserContextProvider>
    </>
  );
};
